import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/reports/autocompleteoverdue' }

type Params = never
type Body = never
type Query = never
type Output = never

export type AutocompleteOverdueReportsEndpoint = Endpoint<Params, Body, Query, Output>

export const autocompleteOverdueReportsRequest = (
    request: Request,
    args: RequestArgs<AutocompleteOverdueReportsEndpoint>
) => request<AutocompleteOverdueReportsEndpoint>(route, args)
